import React from 'react';
import { injectIntl } from 'react-intl';
import { Row, Col } from 'react-bootstrap';

import EntityPropsUpdater from 'component/EntityPropsUpdater';

import FormAutocomplete from 'components/forms/FormAutocomplete';
import FormSwitchery from 'components/forms/FormSwitchery';

class CategoryFacetData extends EntityPropsUpdater {
  constructor(props) {
    super(props);

    this.defaultFieldTree = ['facets', props.index];
  }

  render() {
    const { data, intl, index } = this.props;
    const messages = intl.messages;

    return (
      <Row>
        <Col xs={12} md={4}>
          <div class="panel panel-transparent">
            <div class="panel-body">
              <p className="form-group-title">
                {messages.filter} {index + 1}
              </p>
              <div class="form-group-attached">
                <FormAutocomplete
                  label={messages.display}
                  name="display"
                  value={data.getDisplay()}
                  options={[
                    { label: 'List', value: 'list' },
                    { label: 'Select', value: 'select' },
                    { label: 'Number range', value: 'number_range' },
                  ]}
                  onChange={this.updateEntity}
                />
              </div>
              <div class="m-t-10">
                <FormSwitchery
                  checked={data.getIsMultiple()}
                  name="isMultiple"
                  value={1}
                  label={messages.select_multiple}
                  onChange={(name, value) => {
                    this.updateEntity(name, value ? true : false);
                  }}
                />
              </div>
            </div>
          </div>
        </Col>
      </Row>
    );
  }
}

export default injectIntl(CategoryFacetData);
